import { useState, useImperativeHandle, FC } from 'react';
import BaseModal from '@/components/BaseModal';
import './index.scss';

interface propsType {
  cRef?: any;
  openRemined: any;
}
const signInRemind: FC<propsType> = (props) => {
  const { cRef, openRemined } = props;
  const [show, setShow] = useState<boolean>(false); //是否展示
  /**
   * @description: 切换弹框状态
   */
  const open = () => {
    setShow(true);
  };
  /**
   * @description: 关闭
   */
  const close = () => {
    setShow(false);
  };
  // 绑定ref
  useImperativeHandle(cRef, () => ({
    open,
    close,
  }));
  return (
    <BaseModal show={show}>
      <div className="signin-remind">
        <p className="remind__title">海底捞想给您发送提醒通知</p>
        <p className="remind__pagation">
          在签到活动期间，海底捞APP将在每日11:00提醒您签到
        </p>
        <div className="remind__btn">
          <div
            className="remind__btn__not"
            onClick={() => openRemined({ type: 'close' })}
          >
            不允许
          </div>
          <div
            className="remind__btn__allow"
            onClick={() => openRemined({ type: 'open', needApi: true })}
          >
            允许
          </div>
        </div>
      </div>
    </BaseModal>
  );
};

export default signInRemind;
